import { render, staticRenderFns } from "./CallMessage.vue?vue&type=template&id=577ecf48&scoped=true&"
import script from "./CallMessage.vue?vue&type=script&lang=js&"
export * from "./CallMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577ecf48",
  null
  
)

export default component.exports